import * as actionTypes from "../actionTypes.js";

const initialState = {
  connectionsList: null,
  operationsList: null, 
  ticketsList: null,

  // mapping tables
  classesMappingList: null,
  accountsMappingList: null, 
  salesTaxesMappingList: null, 
  itemsMappingList: null, 
  vendorsMappingList: null, 
  customersMappingList: null,
  billsMappingList: null, 
  billPaymentsMappingLlist: null, 
  invoiceMappingList: null,
  invoicePaymentsMappingList: null, 
  journalEntriesMappingList: null, 
  checksMappingList: null

};

const businessAccountingTPIQBDReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CONNECTIONS_BIZ_ACCTPI_QBD:
      return { ...state, connectionsList: action.payload };
    case actionTypes.GET_OPERATIONS_BIZ_ACCTPI_QBD:
      return { ...state, operationsList: action.payload };
    case actionTypes.GET_TICKETS_BIZ_ACCTPI_QBD:
      return { ...state, ticketsList: action.payload };

    case actionTypes.GET_CLASSES_MAPPING_BIZ_ACCTPI_QBD:
      return { ...state, classesMappingList: action.payload };
    case actionTypes.GET_ACCOUNTS_MAPPING_BIZ_ACCTPI_QBD:
      return { ...state, accountsMappingList: action.payload };
    case actionTypes.GET_SALES_MAPPING_TAXES_BIZ_ACCTPI_QBD:
      return { ...state, salesTaxesMappingList: action.payload };
    case actionTypes.GET_ITEMS_MAPPING_BIZ_ACCTPI_QBD:
      return { ...state, itemsMappingList: action.payload };
    case actionTypes.GET_VENDORS_MAPPING_BIZ_ACCTPI_QBD:
      return { ...state, vendorsMappingList: action.payload };
    case actionTypes.GET_CUSTOMERS_MAPPING_BIZ_ACCTPI_QBD:
      return { ...state, customersMappingList: action.payload };
    case actionTypes.GET_BILLS_MAPPING_BIZ_ACCTPI_QBD:
      return { ...state, billsMappingList: action.payload };
    case actionTypes.GET_BILL_PAYMENTS_MAPPING_BIZ_ACCTPI_QBD:
      return { ...state, billPaymentsMappingLlist: action.payload };
    case actionTypes.GET_INVOICES_MAPPING_BIZ_ACCTPI_QBD:
      return { ...state, invoiceMappingList: action.payload };
    case actionTypes.GET_INVOICE_PAYMENTS_MAPPING_BIZ_ACCTPI_QBD:
      return { ...state, invoicePaymentsMappingList: action.payload };
    case actionTypes.GET_JOURNAL_ENTRIES_MAPPING_BIZ_ACCTPI_QBD:
      return { ...state, journalEntriesMappingList: action.payload };
    case actionTypes.GET_CHECKS_MAPPING_BIZ_ACCTPI_QBD:
      return { ...state, checksMappingList: action.payload };

      
    case actionTypes.LOG_OUT:
      return initialState;

    default:
      return state;
  }
};

export default businessAccountingTPIQBDReducer;